import BaseService from './base.service';

export default class RecruitmentCategoryService extends BaseService {
    constructor(ctx) {
        super(ctx);
    }

    getRecruitmentCategoryOptions = (query = {}) => {
        return this.get('/recruitment-category/get-options', query);
    };
}
